import React from "react";

export default function MessagePhonePreview({ template }) {
  if (!template) {
    return (
      <div style={styles.container}>
        <p style={{ color: "#aaa" }}>Sin vista previa</p>
      </div>
    );
  }

  const { type, content, title, imageUrl } = template;

  return (
    <div style={styles.phone}>
      <div style={styles.header}>
        <span style={{ fontWeight: "bold" }}>Vista previa</span>
      </div>

      <div style={styles.chatArea}>
        <div style={styles.bubble}>

          {/* TÍTULO */}
          {title && <div style={styles.title}>{title}</div>}

          {/* TEXTO */}
          {type === "text" && <div style={styles.text}>{content}</div>}

          {/* IMAGEN */}
          {type === "image" && (
            <>
              <img
                src={
                  imageUrl ||
                  "https://via.placeholder.com/300x200?text=Imagen"
                }
                style={styles.image}
                alt="Preview"
              />

              <div style={styles.text}>{content}</div>
            </>
          )}

        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: 20,
    textAlign: "center",
  },
  phone: {
    width: 320,
    height: 550,
    border: "1px solid #ccc",
    borderRadius: 30,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    background: "#e5ddd5",
  },
  header: {
    background: "#075e54",
    color: "white",
    padding: 12,
    textAlign: "center",
  },
  chatArea: {
    padding: 14,
    overflowY: "auto",
    flex: 1,
  },
  bubble: {
    maxWidth: "90%",
    background: "white",
    padding: 10,
    borderRadius: 12,
    marginBottom: 12,
  },
  title: {
    fontWeight: "bold",
    marginBottom: 6,
  },
  text: {
    fontSize: 14,
    color: "#333",
    whiteSpace: "pre-line",
  },
  image: {
    width: "100%",
    borderRadius: 12,
    marginBottom: 8,
  },
};
